import { documentsService } from "services";
import { toastr } from "react-redux-toastr";

export const storeFolderConstants = {
	GET_REQUEST: "STORE_FOLDERS_GET_REQUEST",
	GET_SUCCESS: "STORE_FOLDERS_GET_SUCCESS",
	GET_FAILURE: "STORE_FOLDERS_GET_FAILURE",
};

export const storeFoldersActions = {
	getStoreFolders,
};

function getStoreFolders() {
	return (dispatch) => {
		dispatch(request());

		documentsService.getStoreFolders().then(
			(response) => {
				dispatch(success(response.data));
			},
			(error) => {
				dispatch(failure(error.toString()));
				toastr.error("Error", "No se pudieron cargar las carpetas");
			}
		);
	};

	function request() {
		return { type: storeFolderConstants.GET_REQUEST };
	}
	function success(folders) {
		return { type: storeFolderConstants.GET_SUCCESS, payload: folders };
	}
	function failure(error) {
		return { type: storeFolderConstants.GET_FAILURE, payload: error };
	}
}

